import { PERFORMANCE_STATUS } from 'modules/campaigns/config';
import { CHANNEL_TYPE } from 'modules/campaigns/config/creativeConsts';
import { ITEM_CREATIVE_TYPE } from 'modules/campaigns/modules/creative-creator/constants/itemCreativeType';
import EnumValueCellRenderer from './EnumValueCellRenderer';

export const ChannelTypeCellRenderer = props => {
    const { msgIdPrefix, value, emptyValue, ...rest } = props;
    const isDisplay = value === PERFORMANCE_STATUS.HTML_CARD || value === ITEM_CREATIVE_TYPE.DISPLAY;
    const channelTypeValue = isDisplay ? CHANNEL_TYPE.SPONSORED_DISPLAY : CHANNEL_TYPE.SPONSORED_REGULAR;

    return (
        <EnumValueCellRenderer value={channelTypeValue} msgIdPrefix={msgIdPrefix} emptyValue={emptyValue} {...rest} />
    );
};
